import React, { Component } from "react";
import cn from "classnames";
import { FormattedMessage } from "react-intl";

import { aspectRatio as ar, isMobile, pianoParser } from "../../../../../common/parameters";
import { IBar, IPitch } from "../../../../../common/types";

import Icon from "../../../../icon";
import piano from "../../../../piano";

import { getAccidentals } from "../../../Score/score-display/utils";
import { getPitchPositions } from "../../../Score/score-display/methods/pitchPositions";
import { getDistribution, getBarWidth } from "../../../Score/score-display/methods/distribution";
import { paddingSide, clefWidth, doClefWidth, accidentalWidth, accidentalMargin, signatureWidth } from "../../../Score/score-display/parameters";
import { parseDo } from "../../../Score/methods/changeDo";
import Score from "../../../Score/score-display";

import Wrapper from "../../Wrapper";

import MessageDisplay from "../Common/MessageDisplay";
import getBirdsPath from "../Common/getBirdsPath";
import NotEdited from "../Common/NotEdited";
import getScore from "../Common/getScore";
import getScale from "../Common/getScale";
import getKeyOffset from "../Common/getKeyOffset";
import play, { resetPlay } from "../Common/play";
import { INotationThis } from "../Common/interfaces";

import { SubmitButton, PlayBtn, CheckPlayBtn, Label } from "../common-style";

import BarDrag from "./BarDrag";
import { Drop, Playground, Asset1Wrapper, ScoreWrapper, ScorePositioner } from "./styles";
import messages from "./messages";
import { isBarsSame, isNearAnyDrop, randomizeOrder } from "./utils";
import { IProps, IState } from "./interfaces";

class BarSorting2 extends Component<IProps, IState> {
    static defaultProps = {
        handlePlayCount: () => { },
        handleFailCount: () => { },
    };
    play = play.bind(this as unknown as INotationThis);
    max_zIndex = 1;
    originalDrags: IState["drags"] = [];
    playgroundRef?: HTMLDivElement;
    scoreRef?: HTMLDivElement;
    lastScale?: number;
    pauseOffset?: number;
    isCheckPlayPause?: boolean;
    timeout: ReturnType<typeof setTimeout>;
    constructor(props: IProps) {
        super(props);
        const { task, plan } = props;
        const notes = [];
        const notesToLoad = new Set<number>();
        const score = getScore(plan, task);
        if (score) {
            const accidentals = getAccidentals(score);
            const maxVoice = [0, 1, 2, 3, 4, 5].filter(v => score["bars" + (v || "")]).pop() as number;
            for (let v = 0; v <= maxVoice; v++) {
                const bars = score["bars" + (v || "")] as IBar[];
                for (let b = 0; b < bars.length; b++) {
                    const doPos = parseDo(accidentals[b]);
                    const bar = bars[b];
                    if (bar === null || !bar.notes) continue;
                    for (let n = 0; n < bar.notes.length; n++) {
                        const note = bar.notes[n];
                        if (note.r) {
                            notes.push({ rest: true });
                        } else {
                            if (!note.p) {
                                continue;
                            }
                            let pianoNote =
                                60 +
                                pianoParser[(note.p as IPitch).s] +
                                ((note.p as IPitch).a || 0) +
                                getKeyOffset(doPos.value + 6) +
                                doPos.alt +
                                (((note.p as IPitch).o || 0) + (score["octave" + v] || 0)) * 12;
                            notesToLoad.add(pianoNote);
                            let newNote = {
                                l: note.l,
                                d: note.d,
                                t: note.t,
                                piano: pianoNote,
                            };
                            if (note.d) {
                                newNote.d = 1;
                            }
                            notes.push(newNote);
                        }
                    }
                }
            }
        }
        if (!props.preview) {
            if (process.env.WEBPACK) {
                [...notesToLoad].forEach(note => piano.load(note));
            }
        }

        this.state = {
            width: 0,
            height: 0,
            drops: [],
            drags: [],
            zIndex: [],
            dropTarget: null,
            solutions: [],
            incorrectBars: null,
            randomOrder: [],
            playing: false,
            submitable: false,
            completed: false,
            scale: 1,
            scoreScale: 1,
            scorePaddingLeft: 0,
            scorePaddingTop: 0,
            notes,
            currentPlayingBar: null,
            frameScale: 1,
            transition: false,
            dropBarRefs: [],
            playingBar: 0,
            lineHeights: [],
            layout: "vertical",
            checkPlaying: false,
            playingNote: [],
            take: 0,
        };

        if (props.setReset) {
            props.setReset(this.resetTask);
        }
        if (props.saveState) {
            props.saveState(this.saveState);
        }
        if (props.restoreState) {
            props.restoreState(this.restoreState);
        }
        if (props.showSolution) {
            props.showSolution(this.showSolution);
        }
    }

    resetTask = () => {
        this.setState({
            submitable: false,
            take: this.state.take + 1,
            completed: false,
            incorrectBars: null,
            drags: JSON.parse(JSON.stringify(this.originalDrags || [])) || [],
            solutions: this.originalDrags.map(() => null),
        });
    };
    saveState = () => {
        return {
            drags: this.state.drags || [],
            zIndex: this.state.zIndex,
            solutions: this.state.solutions,
            incorrectBars: this.state.incorrectBars,
            submitable: this.state.submitable,
            completed: this.state.completed,
            randomOrder: this.state.randomOrder,
        };
    };
    restoreState = (state: IState) => {
        this.setState({
            drags: state.drags || [],
            zIndex: state.zIndex,
            solutions: state.solutions,
            incorrectBars: state.incorrectBars,
            submitable: state.submitable,
            completed: state.completed,
            randomOrder: state.randomOrder,
        });
    };
    showSolution = () => {
        let solutions: IState["solutions"] = [];
        const { drags, drops } = this.state;
        drops.forEach((drop, i) => {
            const index = this.state.randomOrder.indexOf(i);
            solutions[i] = index;
            drags[index].t = drop.t;
            drags[index].l = drop.l;
        });
        this.setState({
            solutions,
            drags,
            completed: true,
        });
    };
    blur = () => {
        this.play();
    };
    componentDidMount() {
        this.forceUpdate();
        window.addEventListener("resize", this.resize);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize);
        clearTimeout(this.timeout);
        if (this.state.playing) {
            this.play();
        }
    }

    resize = () => {
        if (!this.playgroundRef) return;
        const { height: playgroundHeight } = this.playgroundRef.getBoundingClientRect();
        const frameScale = playgroundHeight / ar.height;
        this.setState({ frameScale });
    };

    componentDidUpdate(prevProps: IProps) {
        if (prevProps.isLow !== this.props.isLow) {
            this.resize();
        }
    }
    loaded = () => {
        const { task, preview, plan } = this.props;
        const score = getScore(plan, task)!;
        const scale = getScale(plan, task);
        const { scorePaddingLeft, scorePaddingTop = 0, scoreScale, frameScale, lineHeights, layout } = this.state;
        const totalVoices = [0, 1, 2, 3, 4, 5].filter(v => score["bars" + (v || "")]).pop()! + 1;
        const accidentals = getAccidentals(score);
        const { pitchPositions } = getPitchPositions({ score, accidentals });
        if (!score.bars) return null;
        const scoreTotalWidth = this.scoreRef!.offsetWidth;
        const { signatures, barlines, settings } = score;
        const { distribution: systems } = getDistribution({
            scoreTotalWidth,
            score,
            paddingSide,
            signatures,
            barlines,
            scale,
            settings,
            editor: false,
            accidentals,
            pitchPositions,
        });
        const barWidths: number[] = [];
        const barNumbers: number[] = [];
        systems!.forEach(system => {
            barNumbers.push(...system);
        });
        let isLastBarExists = false;
        for (let v = 0; v < totalVoices; v++) {
            const bars = score["bars" + (v || "")];
            let bar = barNumbers[barNumbers.length - 1];
            if (bars && bars[bar] && bars[bar].notes.length > 0) {
                isLastBarExists = true;
            }
        }
        if (!isLastBarExists) {
            barNumbers.pop();
        }
        const voiceBarLengths = [0, 1, 2, 3, 4, 5]
            .filter(n => score["bars" + (n || "")])
            .map(n => score["bars" + (n || "")].length);
        const lastBar = Math.max.apply(Math, voiceBarLengths);
        for (let barNumber of barNumbers) {
            barWidths[barNumber] = getBarWidth({
                signatures,
                score,
                bar: barNumber,
                barlines,
                editor: false,
                pitchPositions,
                lastBar,
                lowerText: score.settings.lowerText,
                lowerText2: score.settings.lowerText2,
                noteDistance: score.settings.noteDistance || 1,
                accidentals,
            }).barWidth;
        }
        const drops = [];
        const hasClef = settings.staffLines && !settings.stick;

        let getStartX = (totalAccidentals: number) =>
            scorePaddingLeft * scoreScale +
            18 * scoreScale +
            (hasClef ? (score.hideClefs ? 0 : score.doClef ? doClefWidth : clefWidth) * scoreScale * scale : 0) +
            (hasClef ? (accidentalMargin + (score.doClef ? 0 : totalAccidentals) * accidentalWidth) * scoreScale * scale : 0) +
            -2 * scoreScale * scale;

        let currentLine = 0;
        let y = 24 * scoreScale + (layout === "vertical" ? scorePaddingTop : 0);
        let maxHeight = 0;
        const dropBarRefs: IState["dropBarRefs"] = [];
        for (let system of systems!) {
            const totalAccidentals = accidentals[system[0]];
            let x = getStartX(Math.abs(totalAccidentals.i));
            let currentSignatureWidth = 0;
            if (signatures.findIndex(s => s.bar === system[0]) === -1) {
                const accidentalDifference = Math.abs(totalAccidentals.i) - Math.abs((accidentals[1] || accidentals[0]).i);
                currentSignatureWidth = (Math.max(0, signatureWidth - accidentalDifference * accidentalWidth)) * scoreScale * scale
                x += currentSignatureWidth;
            }
            for (let barNumber of system) {
                if (!barNumbers.includes(barNumber)) continue;
                let barWidth = Math.round(barWidths[barNumber] * scoreScale * scale);
                if (signatures.findIndex(s => s.bar === barNumber) !== -1) {
                    const removedValue = currentSignatureWidth || (signatureWidth * scoreScale * scale);
                    barWidth -= removedValue;
                    x += removedValue;
                }
                let addToX = 0;
                const barline = barlines.find(b => b.bar === barNumber);
                if (barline) {
                    if (barline.type === "double") {
                        addToX = 6 * scale * scoreScale;
                        barWidth -= addToX;
                    } else if (barline.type === "final") {
                        addToX = 9 * scale * scoreScale;
                        barWidth -= addToX;
                    }
                }
                for (let v = 0; v < totalVoices; v++) {
                    if (!score["bars" + (v || "")][barNumber]) continue;
                    const h = Math.round((lineHeights[currentLine][v] / frameScale) * scoreScale);
                    maxHeight = Math.max(maxHeight, h);

                    dropBarRefs.push({
                        v,
                        b: barNumber,
                    });
                    let t = Math.round(
                        y + ((v * lineHeights[currentLine][v === 0 ? 0 : v - 1]) / frameScale) * scoreScale + 60
                    );
                    const widthReduction = accidentals[barNumber + 1]?.isVisible
                        ? ((accidentals[barNumber + 1].i * accidentalWidth + accidentalMargin) * scoreScale * scale) 
                        : 0;
                    drops.push({
                        bar: barNumber,
                        voice: v,
                        w: Math.round(barWidth) - widthReduction,
                        h,
                        l: Math.round(x),
                        t,
                        vertTop: t - scorePaddingTop,
                    });
                }
                x += addToX;
                x += barWidth;
            }
            if (lineHeights[currentLine]) {
                y += (lineHeights[currentLine].reduce((a, b) => a + b) / frameScale) * scoreScale;
            }
            if (totalVoices > 1) {
                y += 26 * scoreScale;
            }
            currentLine++;
        }
        let drags: IState["drags"] = JSON.parse(JSON.stringify(drops));
        let x = 0 + (layout === "vertical" ? ar.width / 2 : 0);
        let randomOrder = randomizeOrder(drops.length);
        if (this.state.randomOrder.length > 0) randomOrder = this.state.randomOrder;
        y = 60 + 12 + (layout === "horizontal" ? (ar.height - 60) / 2 : scorePaddingTop);
        if (!preview) {
            drags = drags.map((d, index) => {
                const drag = drags[randomOrder[index]];
                const { w } = drag;
                if (x + w + 12 > ar.width) {
                    x = 0 + (layout === "vertical" ? ar.width / 2 : 0);
                    y += maxHeight + 12;
                }
                x += w + 12;
                return {
                    ...drag,
                    t: y,
                    l: x - w,
                };
            });
        } else {
            drags = drags.map((d, index) => {
                const drag = drags[randomOrder[index]];
                return {
                    ...drag,
                };
            });
        }
        let solutions: IState["solutions"] = drops.map(() => null);
        this.originalDrags = JSON.parse(JSON.stringify(drags));
        if (this.state.drags.length > 0) drags = this.state.drags;
        if (this.state.solutions.length > 0) solutions = this.state.solutions;
        this.setState({ drops, drags, solutions, randomOrder, dropBarRefs });
    };

    draggedToDrop = (index: number, dropTarget: number) => {
        const { solutions, drags, drops } = this.state;
        if (typeof solutions[dropTarget] === "number") {
            drags[solutions[dropTarget]!].l = this.originalDrags[solutions[dropTarget]!].l;
            drags[solutions[dropTarget]!].t = this.originalDrags[solutions[dropTarget]!].t;
        }
        solutions[dropTarget] = index;
        drags[index].l = drops[dropTarget].l;
        drags[index].t = drops[dropTarget].t;
        this.setState({ solutions, drags }, () => this.checkReady());
    };

    checkReady = () => {
        const { solutions } = this.state;
        let submitable;
        if (solutions.filter(solution => solution === null).length === 0) {
            submitable = true;
        } else {
            submitable = false;
        }
        if (this.state.submitable !== submitable) {
            this.setState({ submitable });
        }
    };

    checkSolutions = () => {
        const { solutions, randomOrder, dropBarRefs } = this.state;
        const { task, plan } = this.props;
        const score = getScore(plan, task)!;
        let incorrectBars: IState["incorrectBars"] = [];
        solutions.forEach((solution, index) => {
            if (randomOrder[solution!] !== index) {
                const bar = score["bars" + (dropBarRefs[index].v || "")][dropBarRefs[index].b];
                const solutionBar =
                    score["bars" + (dropBarRefs[randomOrder[solution!]].v || "")][dropBarRefs[randomOrder[solution!]].b];
                if (!isBarsSame(bar, solutionBar)) {
                    incorrectBars!.push(solution!);
                }
            }
        });
        if (incorrectBars.length === 0) {
            if (this.props.completed) {
                this.props.completed("barSorting");
            }
        } else {
            this.props.handleFailCount!();
        }
        this.setState({ incorrectBars, completed: incorrectBars.length === 0 });
    };

    draggedFromDrop = (index: number) => {
        const { solutions } = this.state;
        solutions.forEach((solution, solutionIndex) => {
            if (solution === index) {
                solutions[solutionIndex] = null;
            }
        });
        this.setState({ solutions, incorrectBars: null, submitable: false });
    };

    getNextDropTarget = () => {
        const { dropBarRefs, solutions } = this.state;
        let minBar = Math.min.apply(
            Math,
            dropBarRefs.map(d => d.b)
        );
        let maxBar = Math.max.apply(
            Math,
            dropBarRefs.map(d => d.b)
        );
        let maxVoice = Math.max.apply(
            Math,
            dropBarRefs.map(d => d.v)
        );
        for (let v = 0; v <= maxVoice; v++) {
            for (let b = minBar; b <= maxBar; b++) {
                const dropIndex = dropBarRefs.findIndex(d => d.b === b && d.v === v);
                if (dropIndex > -1 && solutions[dropIndex] === null) return dropIndex;
            }
        }
    };
    clickDrag = (index: number) => {
        const { solutions, drags, drops } = this.state;
        if (solutions.indexOf(index) === -1) {
            let dropTarget = this.getNextDropTarget() as number;
            solutions[dropTarget] = index;
            drags[index].l = drops[dropTarget].l;
            drags[index].t = drops[dropTarget].t;
        } else {
            solutions[solutions.indexOf(index)] = null;
            drags[index].l = this.originalDrags[index].l;
            drags[index].t = this.originalDrags[index].t;
        }
        this.setState({ solutions, drags, dropTarget: null, incorrectBars: null, transition: true }, () =>
            this.checkReady()
        );
    };

    setRef = (ref: HTMLDivElement) => {
        const { plan, task } = this.props;
        const scale = getScale(plan, task);
        if (ref && (scale !== this.lastScale || !scale) && !this.scoreRef) {
            this.timeout = setTimeout(() => {
                let elements = ref.childNodes;
                if (elements && elements.length) {
                    if (this.scoreRef) return; // TODO csak egyszer és menjen középre mindenhogy

                    this.scoreRef = ref;
                    const { height: playgroundHeight } = this.playgroundRef!.getBoundingClientRect();
                    const frameScale = playgroundHeight / ar.height;
                    const totalLines = elements.length;
                    let height = 0;
                    const lineHeights: number[][] = [];
                    for (let l = 0; l < totalLines; l++) {
                        lineHeights.push([]);
                        for (let v = 0; v < elements[l].childNodes.length; v++) {
                            const line = elements[l].childNodes[v] as HTMLDivElement;
                            const lineHeight =
                                (+line.style.paddingTop.slice(0, -2) + +line.style.paddingBottom.slice(0, -2)) *
                                frameScale;
                            lineHeights[l].push(lineHeight);
                            height += lineHeight;
                        }
                    }
                    height += 50;
                    const width = (elements[0] as HTMLDivElement).getBoundingClientRect().width + 40;
                    const scoreAr = width / height; // height padding?
                    if (scoreAr > 1.8) {
                        if (scoreAr < ar.width / ((ar.height - 60) / 2)) {
                            const scoreScale = (((ar.height - 60) / 2) * frameScale) / height;
                            const scorePaddingLeft = (ar.width - width - 40) / 2;
                            this.setState({
                                lineHeights,
                                frameScale,
                                scoreScale,
                                scorePaddingLeft,
                                layout: "horizontal",
                            });
                        } else {
                            this.setState({
                                lineHeights,
                                frameScale,
                                scoreScale: (ar.width * frameScale) / width,
                                scorePaddingLeft: 0,
                                layout: "horizontal",
                            });
                        }
                        this.lastScale = scale;
                        this.timeout = setTimeout(() => {
                            const width = (elements[0] as HTMLDivElement).getBoundingClientRect().width + 40;
                            const scoreAr = width / height;
                            if (scoreAr < ar.width / ((ar.height - 60) / 2)) {
                                const scoreScale = (((ar.height - 60) / 2) * frameScale) / height;
                                this.setState(
                                    {
                                        lineHeights,
                                        frameScale,
                                        scoreScale,
                                        scorePaddingLeft: 0,
                                        layout: "horizontal",
                                    },
                                    () => {
                                        const newWidth =
                                            (elements[0] as HTMLDivElement).getBoundingClientRect().width + 40 * frameScale * scoreScale;
                                        const scorePaddingLeft =
                                            (ar.width * frameScale - newWidth) / 2 / frameScale / scoreScale;
                                        this.setState(
                                            {
                                                scorePaddingLeft,
                                            },
                                            () => {
                                                this.loaded();
                                            }
                                        );
                                    }
                                );
                            } else {
                                this.setState({
                                    lineHeights,
                                    frameScale,
                                    scoreScale: (ar.width * frameScale) / width,
                                    scorePaddingLeft: 0,
                                    layout: "horizontal",
                                });
                                this.loaded();
                            }
                        });
                    } else {
                        let scoreScale = 1;
                        if (scoreAr < ar.width / 2 / (ar.height - 60)) {
                            scoreScale = ((ar.height - 60) * frameScale) / (height + 50);
                            const scorePaddingLeft = 0;
                            this.setState({
                                lineHeights,
                                frameScale,
                                scoreScale,
                                scorePaddingLeft,
                                layout: "vertical",
                            });
                        } else {
                            scoreScale = ((ar.width / 2) * frameScale) / width;
                            const scorePaddingLeft =
                                ((ar.height - 60) / scoreScale - height / frameScale / scoreScale) / 2;
                            this.setState({
                                lineHeights,
                                frameScale,
                                scoreScale,
                                scorePaddingLeft,
                                layout: "vertical",
                            });
                        }
                        this.lastScale = scale;
                        this.timeout = setTimeout(() => {
                            const width = (elements[0] as HTMLDivElement).getBoundingClientRect().width;

                            if (scoreAr < ar.width / 2 / (ar.height - 60)) {
                                const scorePaddingLeft =
                                    (ar.width / 2 - width / frameScale - 40 * scoreScale) / scoreScale;
                                this.setState(
                                    {
                                        scorePaddingLeft,
                                    },
                                    () => {
                                        this.loaded();
                                    }
                                );
                            } else {
                                scoreScale = ((ar.width / 2) * frameScale) / (width + 20) / 2;
                                this.setState({
                                    lineHeights,
                                    frameScale,
                                    scoreScale,
                                    scorePaddingLeft: 0,
                                    layout: "vertical",
                                });
                                this.timeout = setTimeout(() => {
                                    const newHeight = (elements[0] as HTMLDivElement).getBoundingClientRect().width / frameScale;
                                    const scorePaddingTop = (ar.height - 60 - newHeight) / 2;
                                    this.setState(
                                        {
                                            scorePaddingTop,
                                        },
                                        () => {
                                            this.loaded();
                                        }
                                    );
                                });
                            }
                        });
                    }
                }
            });
        }
    };

    updateZindex = (index: number) => {
        this.max_zIndex++;
        const { zIndex } = this.state;
        zIndex[index] = this.max_zIndex;
        this.setState({ zIndex });
    };

    onDragStart = () => {
        this.checkReady();
    };
    onStop = () => {
        this.setState({ transition: true });
    };
    onDrag = (left: number, top: number, index: number) => {
        const { drops, drags } = this.state;
        let dropTarget = isNearAnyDrop({ drops, left, top });
        if (dropTarget !== null) {
            this.draggedToDrop(index, dropTarget);
        } else {
            drags[index].l = left;
            drags[index].t = top;
            this.setState({ drags });
        }
    };

    onPlayBar = (index: number) => {
        const { dropBarRefs, randomOrder } = this.state;
        this.setState({ playingBar: index });
        this.play(false, undefined, dropBarRefs[randomOrder[index]]);
    };
    render() {
        const { task, isLow, isDemo, plan, handleHomeworkNext, isEaster, isChristmas } = this.props;
        const { data } = task;
        const {
            solutions,
            submitable,
            completed,
            transition,
            scoreScale,
            scorePaddingLeft,
            randomOrder,
            playingBar,
            drops,
            drags,
            frameScale,
            zIndex,
            incorrectBars,
            playing,
            currentPlayingBar,
            dropBarRefs,
            scorePaddingTop = 0,
            layout,
            checkPlaying,
            playingNote,
            take,
        } = this.state;
        const score = getScore(plan, task);
        const scale = getScale(plan, task);
        if (!score)
            return (
                <div>
                    <Wrapper>
                        <NotEdited />
                    </Wrapper>
                </div>
            );
        let { color } = data;
        return (
            <div>
                <Wrapper isDemo={isDemo}>
                    {isLow && (
                        <>
                            <Asset1Wrapper>
                                <img src={getBirdsPath("/barSorting/asset-01.svg")} alt="decoration" />
                            </Asset1Wrapper>
                        </>
                    )}
                    <Playground
                        isLow={!!isLow}
                        ref={ref => {
                            if (ref) {
                                this.playgroundRef = ref;
                            }
                        }}
                        style={{ opacity: !drops || drops.length === 0 ? 0 : 1 }}
                    >
                        <ScoreWrapper
                            style={{
                                left: 0,
                                right: 0,
                                top: 60 + scorePaddingTop,
                                height: ar.height - 60,
                            }}
                        >
                            <ScorePositioner
                                style={{
                                    transform: `scale(${scoreScale}) translateX(${scorePaddingLeft}px)`,
                                    ...(isChristmas && {
                                        backgroundColor: "rgba(255, 255, 255, 0.6)"
                                    })
                                }}
                            >
                                <Score
                                    score={score}
                                    scale={scale}
                                    setRef={this.setRef}
                                    isSameLineHeight
                                    playing={playing}
                                />
                            </ScorePositioner>
                        </ScoreWrapper>
                        {drops.map((drop, index) => {
                            return (
                                <Drop
                                    key={index}
                                    className={cn(
                                        dropBarRefs[index].b === currentPlayingBar && "Playing",
                                        completed && "HideOnComplete",
                                        isChristmas && "Christmas",
                                    )}
                                    style={{
                                        top: drop.t,
                                        left: drop.l,
                                        width: drop.w,
                                        height: drop.h,
                                    }}
                                />
                            );
                        })}
                        {!!drags &&
                            drops.length === drags.length &&
                            drags.map((drag, index) => {
                                return (
                                    <BarDrag
                                        key={`${index}${take}`}
                                        drag={drag}
                                        isPlaying={
                                            checkPlaying &&
                                            dropBarRefs[solutions.indexOf(index)]?.b === currentPlayingBar
                                        }
                                        frameScale={frameScale}
                                        index={index}
                                        solutions={solutions}
                                        color={color}
                                        zIndex={zIndex[index]}
                                        updateZindex={this.updateZindex}
                                        scoreScale={scoreScale}
                                        drops={drops}
                                        scorePaddingLeft={scorePaddingLeft}
                                        score={score}
                                        scale={scale}
                                        completed={completed}
                                        incorrectBars={incorrectBars}
                                        draggedFromDrop={this.draggedFromDrop}
                                        onDragStart={this.onDragStart}
                                        onStop={this.onStop}
                                        onDrag={this.onDrag}
                                        transition={transition}
                                        clickDrag={this.clickDrag}
                                        randomOrder={randomOrder}
                                        onPlayBar={this.onPlayBar}
                                        playingNote={playingNote}
                                        playingBar={playingBar}
                                        layout={layout}
                                        isChristmas={isChristmas}
                                    />
                                );
                            })}
                    </Playground>
                    {drops && drops.length > 0 && (
                        <PlayBtn
                            isEaster={isEaster}
                            isLow={isLow}
                            resetPlay={this.pauseOffset && !playing && !this.isCheckPlayPause ? resetPlay.bind(this as unknown as INotationThis) : undefined}
                            className={cn("button", "button--play")}
                            onClick={() => {
                                if (isMobile) return;
                                this.play(true, "barSorting2");
                            }}
                            onTouchStart={() => {
                                if (isMobile) this.play(true, "barSorting2");
                            }}
                            disabled={checkPlaying}
                        >
                            {playing ? <Icon i="pause" /> : <Icon i="play" />}
                            <Label>
                                <FormattedMessage {...messages.play} />
                            </Label>
                        </PlayBtn>
                    )}
                    {submitable && drops && drops.length > 0 && (
                        <CheckPlayBtn
                            isEaster={isEaster}
                            isLow={isLow}
                            resetPlay={this.pauseOffset && this.isCheckPlayPause && !playing ? resetPlay.bind(this as unknown as INotationThis) : undefined}
                            className={cn("button", "button--check")}
                            onClick={() => this.play(true, "barSorting2", undefined, true)}
                            disabled={(playing && !checkPlaying) || completed}
                        >
                            {checkPlaying ? <Icon i="pause" /> : <Icon i="play" />}
                            <Label>
                                <FormattedMessage {...messages.check} />
                            </Label>
                        </CheckPlayBtn>
                    )}
                    {submitable && !completed && (!incorrectBars || incorrectBars.length === 0) && (
                        <SubmitButton
                            isEaster={isEaster}
                            isLow={isLow}
                            style={{ top: isLow ? 30 : 6, bottom: "auto" }}
                            className={cn("button")}
                            onClick={this.checkSolutions}
                        >
                            <FormattedMessage {...messages.submit} />
                        </SubmitButton>
                    )}

                    {completed && (
                        <MessageDisplay isChristmas={isChristmas} isLow={!!isLow} type="completed" handleHomeworkNext={handleHomeworkNext} />
                    )}
                    {incorrectBars && incorrectBars.length > 0 && <MessageDisplay isChristmas={isChristmas} isLow={!!isLow} type="incorrect" />}
                </Wrapper>
            </div>
        );
    }
}

export default BarSorting2;
